var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCogSm = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 12,
  height: 12,
  viewBox: "0 0 12 12",
  role: "img"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF3CA0",
  fillRule: "evenodd",
  d: "M6 0c.4 0 .8.4.8.4l.001 1.256a4.5 4.5 0 0 1 1.525.5L9.6 1.2s.4-.08.8.4.4.8.4.8l-.995 1.204c.268.464.451.998.538 1.589h1.25S12 5.6 12 6s-.407.793-.407.793l-1.248.001a4.5 4.5 0 0 1-.5 1.531L10.8 9.6s0 .32-.4.8-.8.4-.8.4l-1.275-.955c-.449.247-.96.417-1.524.499L6.8 11.586S6.4 12 6 12s-.8-.414-.8-.414v-1.242a4.5 4.5 0 0 1-1.525-.499L2.4 10.8s-.319 0-.8-.4-.4-.8-.4-.8l.956-1.274a4.5 4.5 0 0 1-.5-1.532L.406 6.793S0 6.4 0 6s.407-.807.407-.807h1.25c.087-.591.27-1.125.538-1.589L1.2 2.4s0-.32.4-.8c.343-.411.686-.411.777-.403L2.4 1.2l1.274.956c.45-.248.961-.418 1.526-.5V.4S5.6 0 6 0m0 4.4a1.6 1.6 0 1 0 0 3.2 1.6 1.6 0 0 0 0-3.2"
})));
export default SvgCogSm;